/**
 * @fileoverview Индекс безопасности смены.
 */

import type { GameState } from "../state/types";
import { clamp } from "../util/math";
import { frontStage } from "../state/createGame";

/** Посчитать safety 0…100 из снега, льда, очереди, нарушений. */
export function computeSafety(g: GameState): number {
  let s = 100;
  for (const r of g.runways) {
    s -= r.snow * 0.18;
    s -= (r.ice || 0) * 0.35;
    if (r.closed) s -= 4;
  }
  s -= g.vis * 40;
  s -= Math.min(18, g.planes.filter((p) => p.status === "approach").length * 3);
  s -= g.violations * 12;
  s -= g.riskyOps * 3;
  if (g.runways[0]?.closed && g.runways[1]?.closed) s -= 16;
  if (g.clearLockT > 0) s -= 5;
  s -= Math.max(0, (100 - g.paxMood) * 0.08);
  return clamp(Math.round(s), 0, 100);
}

/**
 * Обновить safety / minSafety и при необходимости остановить смену.
 * @returns подпись фронта для HUD
 */
export function tickSafety(
  g: GameState,
  onEnd: (title: string, sub: string) => void,
): { safety: number; frontLabel: string } {
  g.safety = computeSafety(g);
  g.minSafety = Math.min(g.minSafety, g.safety);
  const st = frontStage(g);
  const side = g.front.dir > 0 ? "→ вост." : "← зап.";
  if (g.safety <= 0 && !g.over) {
    onEnd(
      "Критическая безопасность",
      "Оперативный штаб остановил работу аэропорта — риск стал недопустимым.",
    );
  }
  return { safety: g.safety, frontLabel: `${st.name} ${side}` };
}
